import React from 'react'
import { Button } from '@/components/ui/button'
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog'
import DowngradeScreen from '@/assets/utils/screens/DowngradeScreen'
import Insight from '@/assets/utils/icons/Insight'
import {
    CreateSurveyButton,
    SecondaryButton,
} from '@/features/survey-builder/Tabs/CustomButton'
import { Loader2 } from 'lucide-react'

const features = [
    'Unlimited no. of surveys',
    'Unlimited no. of questions per survey',
    'Customizing survey flow',
    'Advanced survey analytics',
    'Advanced survey analytics',
    'Survey targeting',
    'Download survey reports',
]

export const DowngradeModal: React.FC<{
    open: boolean
    onOpenChange: (open: boolean) => void
    onConfirm: () => void
    isLoading?: boolean
}> = ({ open, onOpenChange, onConfirm, isLoading = false }) => {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-[640px] px-0 pb-4 space-y-4">
                <DialogHeader className="px-6">
                    <DialogTitle>
                        Are you sure you want to downgrade?{' '}
                        <span role="img" aria-label="sad">
                            🥺
                        </span>
                    </DialogTitle>
                    <DialogDescription>
                        You'll lose access to the following features by
                        downgrading to Free:
                    </DialogDescription>
                </DialogHeader>
                <div className="flex items-center justify-between gap-8 px-6">
                    <div className="h-[200px]">
                        <DowngradeScreen />
                    </div>
                    <div className="flex flex-col gap-6">
                        <ul className="space-y-4 w-[338px]">
                            {features.map((feature, idx) => (
                                <li
                                    key={feature}
                                    className="flex items-center justify-start gap-[10px]"
                                >
                                    <span className="h-[24px] min-w-[24px] bg-[#E8DAFF] text-[#5D00D6] font-[450] rounded-full flex items-center justify-center text-[12px]">
                                        {idx + 1}
                                    </span>
                                    <div className="font-[550] text-[14px] whitespace-nowrap text-[#4A4A4A]">
                                        {feature}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="bg-[#EAF4FF] text-[#00527C] text-[14px] rounded-[6px] px-2 py-2 my-6 mx-6 flex items-center gap-2">
                    <Insight />
                    Downgrades will be effective at the end of your current
                    billing cycle.
                </div>

                <div className="flex justify-end gap-4 items-center px-6 border-t border-[#E3E3E3] pt-4">
                    <DialogClose asChild>
                        <SecondaryButton text="Close" disabled={isLoading} />
                    </DialogClose>
                    <CreateSurveyButton
                        text={isLoading ? 'Processing...' : 'Downgrade plan'}
                        onClick={onConfirm}
                        disabled={isLoading}
                        icon={
                            isLoading && (
                                <Loader2 className="h-4 w-4 animate-spin" />
                            )
                        }
                    />
                </div>
            </DialogContent>
        </Dialog>
    )
}
